import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { ReleasesSidebarItem } from '../releases/ReleasesSidebarItem';
import { MaintenanceSidebarItem } from '../maintenance/MaintenanceSidebarItem';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:catalog')}
            {/*
              Global Release Feed (spec 004-release-feed) — /releases entry,
              placed directly below Catalog. Flag-aware: renders only when the
              backend `backstage-releases-view` GrowthBook flag is on (falls back
              to app-config releases.enabled), so a disabled feature hides the tab.
            */}
            <ReleasesSidebarItem />
            {/*
              Maintenance Windows (spec 003) — flag-aware entry, placed
              directly below the releases spike entry. Renders only when the
              backend `backstage-maintenance-view` GrowthBook flag is on
              (falls back to app-config maintenance.enabled).
            */}
            <MaintenanceSidebarItem />
            {/*
              The "Create" page (`page:scaffolder`) is intentionally NOT
              surfaced. Net-new Commercial Front projects scaffold from the
              official boilerplates (`nestjs-boilerplate`, `nextjs-boilerplate`)
              via the `luminus-scaffold-from-boilerplate` skill — see
              research R-12 and `docs/cf-onboarding.md`. The `/create` URL
              is handled by `CreateRedirect` (registered below) which sends
              the user to the catalog with a one-shot info alert.
            */}
            {nav.take('page:scaffolder')}
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
